// ==============================
// Company data
// ==============================
export const CompanyName = 'Queen Blaire';
export const CompanyPhoneNumber = ''; // none provided
export const CompanyWhatsappNumber = ''; // none provided
export const CompanyEmailAddress = 'servequeenblaire2626@gmail.com';
export const DirectorName = 'Queen Blaire';
export const LocationCity = 'USA';
export const LocationCountry = 'USA';

// ==============================
// Text / marketing copy
// ==============================
export const CompanyTagLine = `Elite Dominatrix & BDSM Specialist`;
export const MainTitle = 'Your Favorite Muscle Goddess';
export const SubtitleMain = 'Bringing pleasure to submissives!';
export const SubtitleSecondary = `Serving devoted subs across the ${LocationCountry}.`;

// ==============================
// Keywords (SEO – rewritten clean)
// ==============================
export const KeywordsPages = `
  Queen Blaire, Dominatrix, BDSM, Femdom, USA dominatrix, muscle dominatrix,
  fetish sessions, professional dominatrix USA, pegging, latex, dungeon sessions,
  Mistress Blaire, submissive training, muscle goddess, fetish content creator
`;

// ==============================
// Address (optional / minimal)
// ==============================
export const AddressLine1 = '';
export const AddressLine2 = '';
export const AddressLine3 = '';
export const AddressLine4 = '';
export const PostalCode = '';

// ==============================
// URLs – Business
// ==============================
export const FULL_BUSINESS_URL = 'https://www.queenblaire.com';
export const SHORT_BUSINESS_URL = 'queenblaire.com';
export const DISPLAY_BUSINESS_URL = 'www.queenblaire.com';
export const BOOKING_FORM_URL = `${FULL_BUSINESS_URL}/booking`;
export const QuestionaireUrl = 'https://form';

// Tribute / pricing
export const TRIBUTE_AMOUNT = '50+';
export const OUTFIT_REQUEST_AMOUNT = '100';
export const PER_MIN_AMOUNT = '15';

// ==============================
// Cookie settings
// ==============================
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 15000;
export const COOKIE_POLICY_NAME = 'CookiePolicy';
export const DISAGREE_LINK = 'https://google.com';

// ==============================
// Bot
// ==============================
export const BotName = 'Jerry';

// ==============================
// Socials / Adult Platforms
// ==============================
export const FETLIFE_URL = 'https://fetlife.com/DangerousQueen23';
export const MANY_VIDS_URL = 'https://www.manyvids.com/Profile/1006811630/queenblaire/Store/Videos';
export const THRONE_URL = 'https://throne.com/spoilblaire';
export const I_WANT_CLIPS_URL = 'https://IWantQueenBlaire.com';
export const CASH_APP_URL = 'https://cash.app/$GoddessBlaire2626';
export const X_URL = 'https://x.com/queenb2626';
export const APPLE_PAY_EMAIL = 'mailto:@gmail.com';
export const VENMO_URL = 'https://venmo.com/u/';
export const PAYPAL_URL = 'https://www.paypal.com/paypalme/';
export const CLIPS4SALE_URL = 'https://www.clips4sale.com/studio/381395/queen-blaire';
export const WISHLIST_URL = 'https://www.amazon.com/hz/wishlist/';
export const ONLYFANS_URL = '';
export const CHATURBATE_URL = 'https://chaturbate.com/queenb2626/?campaign=QdzcL&disable_sound=0&force=1&join_overlay=1&room=queenb2626&tour=dT8X';
export const DISCORD_URL = 'https://discord.com/users/1408213877501464647';
export const BLUESKY_URL = 'https://bsky.app/profile/queenb2626.bsky.social';
export const TWITTER_URL = 'https://twitter.com/queenb2626';
export const INSTAGRAM_URL = 'https://www.instagram.com';
export const SNAPCHAT_URL = 'https://www.snapchat.com/add/';
export const LOYALFANS_URL = 'https://www.loyalfans.com/queenb2626';
export const TIKTOK_URL = 'https://www.tiktok.com/';
export const YOUPAY_URL = 'https://youpay.me/';
export const SEXT_PANTHER_URL = 'https://www.sextpanther.com/';
export const SCATBOOK_URL = 'https://scatbook.com/';
export const FEET_FINDER_URL = 'https://app.feetfinder.com/userProfile/';
export const TELEGRAM_URL = 'https://t.me/';
export const ETSY_URL = 'https://www.etsy.com/registry';
export const REDDIT_URL = 'https://www.reddit.com/user1/';

// Starter socials array (kept for components)
export const SOCIAL_URLS = [
  X_URL,
  TWITTER_URL,
  DISCORD_URL,
  BLUESKY_URL,
];

// ==============================
// Business / SEO facts
// ==============================
export const BUSINESS_SCHEMA_TYPE = 'ProfessionalService';
export const BUSINESS_OPENING_HOURS = 'Mo-Su 00:00-23:59';
export const BUSINESS_PRICE_RANGE = '$$';
export const BUSINESS_CURRENCY = 'USD';
export const BUSINESS_AREA_SERVED = 'US';
export const BUSINESS_LANGUAGES = ['English'];
export const BUSINESS_SERVICE_TYPES = [
  'Dominatrix Sessions',
  'Fetish Content',
  'Muscle Worship',
  'Femdom Training',
  'Online Sessions',
];

export const BUSINESS_ACCEPTED_PAYMENTS = [
  'Cash',
  'Visa',
  'MasterCard',
  'AmericanExpress',
  'ContactlessPayment',
  'DigitalWallet',
];
export const BUSINESS_CURRENCIES_ACCEPTED = [BUSINESS_CURRENCY];

// ==============================
// Linked-data entity IDs
// ==============================
export const ORG_ID = `${FULL_BUSINESS_URL}/#org`;
export const WEBSITE_ID = `${FULL_BUSINESS_URL}/#website`;

// ==============================
// Map & Geo (none provided)
// ==============================
export const BUSINESS_MAP_URL = null;
export const BUSINESS_GEO = {
  lat: null,
  lng: null,
};

// ==============================
// Fallback OG/Twitter
// ==============================
export const OG_TYPE_DEFAULT = 'website';
export const DEFAULT_OG_TITLE = `${CompanyName} | ${MainTitle}`;
export const DEFAULT_OG_DESCRIPTION = SubtitleMain;

// ==============================
// Media (placeholders — you can replace)
// ==============================
export const PAGE_MEDIA = {
  logo: `${FULL_BUSINESS_URL}/brand/logo.png`,
  homePreview: `${FULL_BUSINESS_URL}/brand/homepage-preview.webp`,
  contactPreview: `${FULL_BUSINESS_URL}/brand/contact-preview.webp`,
  bookingPreview: `${FULL_BUSINESS_URL}/brand/booking-preview.webp`,
  servicesPreview: `${FULL_BUSINESS_URL}/brand/services-preview.webp`,
  productPreview: `${FULL_BUSINESS_URL}/brand/product-preview.webp`,
  maintenancePreview: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.webp`,
  termsPreview: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.webp`,
  errorPreview: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.webp`,
};

export const PageMediaHelper = (key) => PAGE_MEDIA[key];

// ==============================
// Misc
// ==============================
export const GoogleMapsEmbedUrl = '';
export const UPLOAD_CONCURRENCY = 4;
